import { Category } from "constants/events";

import DeliveryValidation from "components/DeliveryGateway/DeliveryValidation";
import Image from "components/Image";
import TrackImpression from "components/TrackImpression";

const DeliveryGatewayHero: React.FC = () => (
  <TrackImpression
    category={Category.deliveryGateFlow}
    label="hero image block"
    className="pt-[90px] pb-[270px] md:pb-[170px] relative"
  >
    <Image
      alt=""
      background={true}
      disableLazyLoad
      mobileSrc="https://leafly-public.imgix.net/web-web/delivery-gateway-hero-mobile.jpg"
      sizes={[544, 767, 1023, 1440, null, 767]}
      src="https://leafly-public.imgix.net/web-web/delivery-gateway-hero-desktop.jpg"
    />
    <div className="flex flex-col justify-center relative items-center text-center px-lg">
      <h1 className="mb-md text-xxl">All the weed, delivered.</h1>
      <p className="mb-xl font-bold">
        Shop, order, hang tight. <br className="md:hidden" /> We’ll arrange the
        rest.
      </p>
      <DeliveryValidation
        trackingCategory={Category.deliveryGateFlow}
        trackingLabel="hero image block"
      />
    </div>
  </TrackImpression>
);

export default DeliveryGatewayHero;
